import React from "react";
import { number, string } from "prop-types";
import { Preloader } from "@icg360/ui-toolkit";
Spinner.propTypes = {
  height: number,
  text: string
};
export default function Spinner(props) {
  var height = props.height,
      text = props.text;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: height ? height + "px" : "150px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      flexDirection: "column",
      color: "#777"
    }
  }, /*#__PURE__*/React.createElement(Preloader, null), text);
}